export default __webpack_public_path__ + "7a07466b3ef6b118e9dd44007a05e076.png";